export default "__VITE_ASSET__DMJIukwy__"